import script from "./FilterAccordionSection.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterAccordionSection.vue?vue&type=script&setup=true&lang=js"

import "./FilterAccordionSection.vue?vue&type=style&index=0&id=1ee585e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ee585e2"]])

export default __exports__